import _plugin_vue_export_helper_default from "../../../_virtual/_plugin-vue_export-helper.js";
import DataTableInput_vue_vue_type_script_setup_true_lang_default from "./DataTableInput.vue.script.js";
/* empty css                             */
//#region src/v2/components/data-table/DataTableInput.vue
var DataTableInput_default = /*#__PURE__*/ _plugin_vue_export_helper_default(DataTableInput_vue_vue_type_script_setup_true_lang_default, [["__scopeId", "data-v-a6f4752a"]]);
//#endregion
export { DataTableInput_default as default };

//# sourceMappingURL=DataTableInput.vue.js.map